export default __webpack_public_path__ + "7f740cd5ec1cc61f3484016ca09562db.svg";